import IconChevronDown from '@apollo/icons/small/IconChevronDown.svg';
import {
  Button,
  Menu,
  MenuButton,
  MenuContent,
  MenuHeader,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  MenuTitle,
} from '@apollo/orbit';
import React from 'react';

import { OperationStatus } from 'src/app/graph/routes';

import { StatusMenuOptions } from './OperationsCheckList';

export const OperationStatusMenu = ({
  statusOptions,
  selectedOptions,
  handleOnChange,
  handleClearAll,
}: {
  statusOptions: StatusMenuOptions[];
  selectedOptions: OperationStatus[];
  handleOnChange: (value: OperationStatus[]) => void;
  handleClearAll: () => void;
}) => {
  return (
    <Menu closeOnSelect={false} placement="bottom-end">
      <MenuButton
        as={Button}
        rightIcon={<IconChevronDown />}
        variant="secondary"
      >
        {`Status ${
          selectedOptions.length ? `(${selectedOptions.length})` : ''
        }`}
      </MenuButton>
      <MenuContent>
        <MenuHeader>
          <MenuTitle>Filter by</MenuTitle>
          <Button size="xs" variant="secondary" onClick={handleClearAll}>
            Clear
          </Button>
        </MenuHeader>
        <MenuList>
          <MenuOptionGroup
            value={selectedOptions}
            type="checkbox"
            onChange={(value) => {
              handleOnChange(value);
            }}
          >
            {statusOptions.map((option) => {
              const { text, value } = option;
              return (
                <MenuItemOption key={value} value={value} type="checkbox">
                  {text}
                </MenuItemOption>
              );
            })}
          </MenuOptionGroup>
        </MenuList>
      </MenuContent>
    </Menu>
  );
};
